// Display-only relabeling: the underlying role value stays 'member'
// everywhere (API contracts, JWT, DB) — only how it reads in the UI changes.
export const roleLabels: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  member: 'Employee',
};

export function roleLabel(role: string): string {
  return roleLabels[role] ?? role;
}

export const roleHierarchy: Record<string, number> = {
  member: 1,
  manager: 2,
  admin: 3,
  owner: 4,
};

export function roleLevel(role: string | undefined): number {
  return roleHierarchy[role || 'member'] || 1;
}
